import { useEffect, useRef, useState } from 'react';

const readNavbarHeight = (navbar: HTMLElement | null): number =>
  navbar ? navbar.offsetHeight : 0;

export const useNavbarHeight = (enabled: boolean) => {
  const navbarRef = useRef<HTMLElement>(null);
  const [navbarHeight, setNavbarHeight] = useState(0);

  useEffect(() => {
    const navbar = navbarRef.current;
    const measureNavbarHeight = () => {
      setNavbarHeight(readNavbarHeight(navbar));
    };

    measureNavbarHeight();

    const resizeObserver = new ResizeObserver(measureNavbarHeight);
    if (navbar) {
      resizeObserver.observe(navbar);
    }
    window.addEventListener('resize', measureNavbarHeight);

    return () => {
      if (navbar) {
        resizeObserver.unobserve(navbar);
      }
      window.removeEventListener('resize', measureNavbarHeight);
    };
  }, [enabled]);

  return { navbarHeight, navbarRef };
};

export default useNavbarHeight;
